import Auth from 'js/background/auth';
import UserManager from 'js/background/user-manager';
import CloudStore from 'js/cloudstore/cloudstore';
import GUIDFactory from 'js/common/identification/guid-factory';
import Nexus from 'js/background/nexus';
import GlobalModules from 'js/background/global-modules';
import BackgroundBus from 'js/bus/background-bus';

function UserInvite() {
	const uiSelf = this;

	uiSelf.inviteUsers = function (arrayOfUserSetups, inviteMessage, callback) {

		const currentUser = UserManager.csoUser;
		const referrerGUID = currentUser.userGUID;

		Assert.isTrue(referrerGUID, `The referrer GUID must be valid`);

		if (arrayOfUserSetups.length === 0) {
			callback({ csoUsers: [] });
			return;
		}

		let emailList = [];

		//Validate the array of User setups
		for (let i = 0; i < arrayOfUserSetups.length; i++) {
			Assert.isTrue(arrayOfUserSetups[i].email, `At minimum, must provide an email for each user to invite.`)
			emailList.push(arrayOfUserSetups[i].email);
		}

		const apiParams = {
			referrer_guid: referrerGUID,
			new_users: arrayOfUserSetups,
			message: inviteMessage,
		};

		Nexus.services.app.api_invite_new_users(apiParams, null, function (result) {

			if (result.success) {

				BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
					objectiveName: "invitedUserToWorkspace",
					objectiveDetails: {
						values: emailList
					}
				});

				const users = result.result.new_users;
				console.log(users);
				const cloudstoreQueryOr = [];

				for (let emailAddress in users) {
					cloudstoreQueryOr.push({
						guid: {
							eq: users[emailAddress]
						}
					})
				}

				if (cloudstoreQueryOr.length > 0) {
					const cloudStoreQuery = {
						filters: {
							context: {
								user_guid: false,
								team_guid: false,
								panel: false,
								feature: false,
								core_context: false,
							},
							meta: {
								or: cloudstoreQueryOr,
								// type: 'User',
							}
						}
					};
					CloudStore.load(cloudStoreQuery, function withUserObjects(csoUsers) {

						if (csoUsers === undefined) {
							Assert.warn("Invite New Users returned, but the CloudStore load to retrive them did not run correctly.");
							callback(undefined);
							return;
						}
						else {
							callback({ csoUsers });
						}
					});
				}
				else {
					// Assert.warn("Invite New Users returned an empty list of users.");
					// Assert.warn(result);
					callback(undefined);
				}
			}
			else {
				Assert.warn("Invite New Users returned an error.");
				Assert.warn(result);
				callback(undefined);
			}
		})
	};

	// uiSelf.sendUserMessage = function(fromUserGUID, notifyUserGUIDArray, subject, message, buttonLink, buttonText, callback){
	// 	Assert.isTrue(fromUserGUID && GUIDFactory.validatePrefixedGUID('USR', fromUserGUID), `Must have a valid User guid in the from param`);
	// 	notifyUserGUIDArray.forEach(function(csoGUID){
	// 		Assert.isTrue(csoGUID && GUIDFactory.validatePrefixedGUID('USR', fromUserGUID), `Recipient guids must all be valid`)
	// 	});
	// 	Assert.isTrue(subject && subject.length > 0, `Must have subject`);
	// 	Assert.isTrue(message && message.length > 0, `Must have message`);
	// 	Assert.isTrue(buttonLink && buttonLink.length > 0, `Must have buttonLink`);

	// 	const apiParams = {
	// 		sending_user: fromUserGUID,
	// 		notify_users: notifyUserGUIDArray,
	// 		subject: subject,
	// 		button_text: buttonText,
	// 		url: buttonLink,
	// 		message: message
	// 	};

	// 	Nexus.services.app.api_email_space_notification(apiParams, null, function withResult(result){
	// 		if(result.success){
	// 			callback(result.result);
	// 		}
	// 		else{
	// 			callback();
	// 		}
	// 	})
	// };

	uiSelf.shareLinkWithUser = function (arrayOfUserEmails, shareTitle, shareLink, callback) {

		Assert.isTrue(shareTitle && shareTitle.length > 0, `Must have message`);
		Assert.isTrue(shareLink && shareLink.length > 0, `Must have shareLink`);

		const apiParams = {
			emails: arrayOfUserEmails,
			share_title: shareTitle,
			url: shareLink,
		};


		Nexus.services.app.api_share_link(apiParams, null, function withResult(result) {
			if (result.success) {
				BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
					objectiveName: "invitedUserToWorkbook",
					objectiveDetails: {
						values: arrayOfUserEmails
					}
				});
				let userEmailCSOGUIDMap = {};

				if (result.result.users && Object.keys(result.result.users).length > 0) {
					// these are USR guids, set them as the return list
					userEmailCSOGUIDMap = result.result.users;
				}

				if (result.result.new_users && Object.keys(result.result.new_users).length > 0) {
					// these aren't USR guids, theyre CSO guids, so we need to load the User CSO
					const userGUIDList = [];
					let emailList = [];
					for (let emailAddress in result.result.new_users) {
						userGUIDList.push(result.result.new_users[emailAddress]);
						emailList.push(emailAddress);
					}
					
					BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
						objectiveName: "invitedUserToWorkspace",
						objectiveDetails: {
							values: emailList
						}
					});

					CloudStore.load({
						filters: {
							context: {
								user_guid: false,
								team_guid: false,
								panel: false,
								feature: false,
								core_context: false,
							},
							meta: {
								guid: {
									in: userGUIDList,
								}
							}
						}
					}, function withUserObjects(csoUsers) {
						if (csoUsers === undefined) {
							Assert.warn("Share Link Users returned, but the CloudStore load to retrive them did not run correctly.");
							callback(userEmailCSOGUIDMap);
							return;
						}
						else {
							for (let userIndex in csoUsers) {
								userEmailCSOGUIDMap[csoUsers[userIndex].emailAddress] = csoUsers[userIndex].userGUID;
							}

							callback(userEmailCSOGUIDMap);
						}
					});

				}
				else {
					callback(userEmailCSOGUIDMap);
				}
			}
			else {
				Assert.warn(`Share Link Users returned an error.`);
				Assert.warn(result);
				callback();
			}
		})
	};

	uiSelf.deactivateUsers = function (deactivateUserGUIDList, callback) {
		const apiParams = {
			user_guids: deactivateUserGUIDList,
		};

		Nexus.services.app.api_deactivate_users(apiParams, null, function withResult(result) {
			if (result.success) {
				console.log("Successfully deactivated users");
			}
			else {
				console.warn("Could not deactivate users");
			}
			callback(result.success);
		})
	};

	uiSelf.getInvitedUsers = function (callback) {
		Auth.getUser(function withUserDetails(userDetails) {
			const referrerGUID = userDetails.user_guid;
			const apiParams = {
				user_guid: referrerGUID,
			};

			Nexus.services.app.api_get_invite_info(apiParams, null, function withResult(result) {
				if (result.success) {
					callback(result.result);
				}
				else {
					callback();
				}
			});
		});
	};


	return uiSelf;
}

export default GlobalModules.register(new UserInvite(), {
	// not sure about this one
	teleported: true,
});